
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";
import { Link } from "react-router-dom";

interface WorkflowCardProps {
  id: string;
  title: string;
  description: string;
  price: number;
  rating: number;
  reviewCount: number;
  platform: string;
  category: string;
  image: string;
}

const WorkflowCard = ({
  id,
  title,
  description,
  price,
  rating,
  reviewCount,
  platform,
  category,
  image
}: WorkflowCardProps) => {
  return (
    <Card className="overflow-hidden hover-scale">
      <Link to={`/workflow/${id}`}>
        <div className="h-48 bg-secondary overflow-hidden">
          <img 
            src={image} 
            alt={title}
            className="w-full h-full object-cover" 
          />
        </div>
      </Link>
      
      <CardHeader className="p-4">
        <div className="flex flex-wrap gap-2 mb-2">
          <Badge variant="secondary" className="font-normal">{platform}</Badge>
          <Badge variant="outline" className="font-normal">{category}</Badge>
        </div>
        <Link to={`/workflow/${id}`} className="hover:underline">
          <h3 className="text-lg font-medium line-clamp-1">{title}</h3>
        </Link>
        <p className="text-sm text-muted-foreground line-clamp-2">{description}</p>
      </CardHeader>
      
      <CardContent className="p-4 pt-0">
        <div className="flex items-center gap-1.5 mb-2">
          <div className="flex items-center">
            {[...Array(5)].map((_, i) => (
              <Star 
                key={i} 
                className={`w-4 h-4 ${i < Math.floor(rating) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} 
              />
            ))}
          </div>
          <span className="text-sm text-muted-foreground">({reviewCount})</span>
        </div>
      </CardContent>
      
      <CardFooter className="p-4 pt-0 flex items-center justify-between">
        <div className="font-semibold">${price.toFixed(2)}</div>
        <Link to={`/workflow/${id}`}>
          <Button variant="outline" size="sm">View Details</Button>
        </Link>
      </CardFooter>
    </Card>
  );
};

export default WorkflowCard;
